export const clearTokens = () => {
  localStorage.removeItem("tokenList");
  localStorage.removeItem("token");
  localStorage.removeItem("permissions");
  localStorage.removeItem("userLevel");
}